/*
 *  **************************************************************************************************************************
 *  This computer software was prepared by Battelle Memorial Institute, hereinafter the Contractor, under Contract No.
 *  DE-AC05-76RL01830 with the Department of Energy (DOE). All rights in the computer software are reserved by
 *  DOE on behalf of the United States Government and the Contractor as provided in the Contract. You are authorized
 *  to use this computer software for Governmental purposes but it is not to be released or distributed to the public.
 *
 *  This material was prepared as an account of work sponsored by an agency of the United States Government. Neither
 *  the United States Government nor the United States Department of Energy, nor the Contractor, nor any of their
 *  employees, nor any jurisdiction or organization that has cooperated in the development of these materials, makes
 *  any warranty, express or implied, or assumes any legal liability or responsibility for the accuracy, completeness,
 *  or usefulness of any information, apparatus, product, software, or process disclosed, or represents that its use
 *  would not infringe privately owned rights.
 *
 *                                      PACIFIC NORTHWEST NATIONAL LABORATORY
 *                                                   operated by
 *                                                    BATTELLE
 *                                                     for the
 *                                        UNITED STATES DEPARTMENT OF ENERGY
 *                                         under Contract DE-AC05-76RL01830
 *  **************************************************************************************************************************
 */
/**
 * Linear Interpolation
 * @param min
 * @param max
 * @param a normalized value
 * @returns value between min and max for a
 */
export const lerp = (min: number, max: number, a: number): number => min * (1 - a) + max * a;

/**
 * Clamp
 * @param a value between min and max
 * @param min
 * @param max
 * @returns value clamped between min and max
 */
export const clamp = (a: number, min = 0, max = 1): number => Math.min(max, Math.max(min, a));

/**
 * Inverse Linear Interpolation
 * @param min
 * @param max
 * @param a value between min and max
 * @returns normalized value between x and y for a
 */
export const invlerp = (min: number, max: number, a: number): number => clamp((a - min) / (max - min));

/**
 * Range
 * @param aMin a value range min
 * @param aMax a value range max
 * @param rMin result range min
 * @param rMax result range max
 * @param a vaue between a range
 * @returns value between result range
 */
export const range = (aMin: number, aMax: number, rMin: number, rMax: number, a: number): number =>
  aMin === aMax ? rMax : lerp(rMin, rMax, invlerp(aMin, aMax, a));
